export interface UtmParams {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_content?: string;
    utm_term?: string;
    gclid?: string;
}

export class UtmUtils {
    private static STORAGE_KEY = 'fp_utm_params';

    /**
     * Captures UTM parameters from URL and saves them to sessionStorage.
     * This ensures attribution is kept even if the user navigates away from the landing page.
     */
    public static captureFromUrl(): void {
        if (typeof window === 'undefined') return;

        const urlParams = new URLSearchParams(window.location.search);
        const utms: UtmParams = {};

        const keys: (keyof UtmParams)[] = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'gclid',
        ];

        let found = false;
        keys.forEach((key) => {
            const val = urlParams.get(key);
            if (val) {
                utms[key] = val;
                found = true;
            }
        });

        if (found) {
            sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(utms));
        }
    }

    /**
     * Gets captured UTM parameters from sessionStorage.
     */
    public static getCapturedParams(): UtmParams {
        if (typeof window === 'undefined') return {};

        const stored = sessionStorage.getItem(this.STORAGE_KEY);
        if (stored) {
            try {
                return JSON.parse(stored);
            } catch (e) {
                return {};
            }
        }
        return {};
    }
}
